import { isValidPhoneNumber } from 'libphonenumber-js';

export const validatePhoneNumber = (phoneNumber: string | null | undefined) => {
	if (!phoneNumber) return undefined;

	if (isValidPhoneNumber(phoneNumber)) {
		return phoneNumber;
	}

	return undefined;
};
